import styled from 'styled-components';
import { useThemeMode } from '../theme';

const StyledTitle = styled.h1<{ $light: boolean }>`
  font-size: 1.25rem;
  font-family: ${({ $light }) => ($light ? 'roman-extended' : 'Jost')};
  font-weight: ${({ $light }) => ($light ? 'normal' : '900')};
  line-height: 1.75rem;
  margin: 0;
  color: ${({ $light, theme }) => ($light ? '#E74F16' : theme.text.default)};
  filter: blur(0.5px);
  position: relative;
  left: 5rem;

  @media (max-width: 630px) {
    left: 12%;
    font-size: 1rem;
  }
`;

export function Title({ children }: { children: React.ReactNode }) {
  const { mode } = useThemeMode();
  return <StyledTitle $light={mode === 'light'}>{children}</StyledTitle>;
}
